module.exports = __webpack_public_path__ + "static/media/wordpress-shopify-integration.18ce50b4.svg";